module.exports = __webpack_public_path__ + "img/docusign.d89e92b1.png";